import { useEmitter } from '@/composables/emitter/index.js'
import { EVENTS } from '@/lib/consts.js'

/*
 * trigger from JS console:
 * document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { detail: { name: "push.open", data: {} }}))
 */

const name = 'push.open'

const callback = (data) => {
  const emitter = useEmitter()
  emitter.emit(EVENTS.WEB_VIEW_PUSH_OPEN, data)
}

export default { name, callback }
